import { render, staticRenderFns } from "./PagedListPopularDestinations.vue?vue&type=template&id=394c4b57&"
import script from "./PagedListPopularDestinations.vue?vue&type=script&lang=js&"
export * from "./PagedListPopularDestinations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports